import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {SpinnerButton} from "../../SpinnerButton";
import { withTranslation } from 'react-i18next';

class AddVtexStoreFormClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountName: '',
            apiKey: '',
            apiToken: '',
            loading: false,
            error: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        const { t } = this.props;
        const accountName = this.state.accountName.trim();
        const apiKey = this.state.apiKey.trim();
        const apiToken = this.state.apiToken.trim();

        if (!accountName) {
            this.setState({ error: t('vtex.account_name_required') });
            return;
        }

        if (!apiKey) {
            this.setState({ error: t('vtex.api_key_required') });
            return;
        }

        if (!apiToken) {
            this.setState({ error: t('vtex.api_token_required') });
            return;
        }

        this.setState({ loading: true, error: null });

        new APIClient(API_URL + 'get_access_tokens/vtex/').call('POST', {
            account_name: accountName,
            api_key: apiKey,
            api_token: apiToken,
        }).then((response) => {
            if (response.status === 'ERROR') {
                this.setState({ loading: false, error: response.error_message });
            } else {
                this.setState({ loading: false });
                this.props.afterSuccessfulSubmit(response.data);
            }
        }).catch(() => {
            this.setState({
                loading: false,
                error: t('vtex.connection_error'),
            });
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <ModalBody>
                    <div className="modal-section">
                        <p>{t('vtex.connect_description')}</p>
                        <div className="form-row">
                            <label>{t('vtex.account_name_label')}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('vtex.account_name_placeholder')}
                                value={this.state.accountName}
                                onChange={(e) => this.setState({ accountName: e.target.value, error: null })}
                            />
                        </div>
                        <div className="form-row">
                            <label>{t('vtex.api_key_label')}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('vtex.api_key_placeholder')}
                                value={this.state.apiKey}
                                onChange={(e) => this.setState({ apiKey: e.target.value, error: null })}
                            />
                        </div>
                        <div className="form-row">
                            <label>{t('vtex.api_token_label')}</label>
                            <input
                                type="password"
                                className="form-control"
                                placeholder={t('vtex.api_token_placeholder')}
                                value={this.state.apiToken}
                                onChange={(e) => this.setState({ apiToken: e.target.value, error: null })}
                            />
                        </div>
                        {this.state.error && (
                            <div className="alert alert-danger" style={{ fontSize: '0.9em', marginTop: '1em', marginBottom: 0 }}>
                                {this.state.error}
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.state.loading ? (
                        <SpinnerButton />
                    ) : (
                        <button
                            className="btn -alt"
                            onClick={this.handleSubmit}
                        >
                            {t('vtex.connect_button')}
                        </button>
                    )}
                </ModalFooter>
            </div>
        );
    }
}

export const AddVtexStoreForm = withTranslation()(AddVtexStoreFormClass);
